<template>
  <section class="bg-neutral-50 py-10 max-w-1192 md:bg-transparent">
    <h3 class="o-heading-2 text-left px-4 md:text-center mb-1" v-text="$t('Loyalty.LoyaltyProgram.NewLoyaltyPage.LoyaltyBenefits.Title')" />
    <div
      ref="scrollContainer"
      class="flex overflow-x-scroll disable-scrollbars horizontal-scroll pr-6 md:pr-0"
      tabindex="0"
      role="region"
      :aria-label="$t('Loyalty.LoyaltyProgram.NewLoyaltyPage.LoyaltyBenefits.Title')"
      @keydown.left="scrollLeft"
      @keydown.right="scrollRight"
    >
      <article
        v-for="(item, i) in items"
        :key="`${item.title}-${i}`"
        class="rounded mt-5 p-5 bg-neutral-00 flex-1 horizontal-scroll-center md:px-5 md:bg-transparent"
        :class="{
          'ml-6 md:pl-3': i !== 0,
          'ml-6 md:pl-0': i === 0
        }"
      >
        <OSvg class="mb-4" :svg="item.svg" />
        <p class="o-heading-4 mb-1 md:mb-2" v-html="item.title" />
        <p class="o-body" v-html="item.description" />
      </article>
    </div>
    <div class="text-center mt-7 lg:mt-12">
      <NewButton
        icon-right="new-chevron-right"
        tag="nuxt-link"
        :to="{ path: $i18n.localePath({ name: 'signup' }) }"
      >
        {{ buttonText }}
      </NewButton>
    </div>
  </section>
</template>

<script>
import { DeliveryTimeInDays } from '@/enums/shipments'
import { addLocalCurrency } from '@/utils/general'
import NewButton from '@/components/NewButton'
import OSvg from '@/components/OSvg'
import { MenPrices, WomenPrices } from '@/enums/products'
import { Currencies } from '@/enums/general'

export default {
  name: 'WhyOta',
  components: { NewButton, OSvg },
  props: {
    buttonText: {
      type: String,
      default: ''
    },
    country: {
      type: String,
      default: 'nl'
    },
    isWomen: {
      type: Boolean,
      default: false
    },
    locale: {
      type: String,
      default: 'nl'
    }
  },
  computed: {
    reasons () {
      const reasons = this.$t('TryItNow.Reasons')

      if (!Array.isArray(reasons)) {
        return []
      }

      const variables = {
        deliveryDays: DeliveryTimeInDays[this.country],
        price: this.boxerPrice,
        womenPrice: this.womenPrice
      }

      const formattedReasons = reasons.map((_, index) => ({
        svg: this.$t(`TryItNow.Reasons[${index}].Svg`),
        title: this.$t(`TryItNow.Reasons[${index}].Title`, variables),
        description: this.$t(`TryItNow.Reasons[${index}].Description`, variables)
      }))

      return formattedReasons
    },
    items () {
      if (this.isWomen) {
        return this.mixedReasons
      }

      return this.reasons
    },
    mixedReasons () {
      const reasons = this.$t('TryItNow.MixedReasons')

      if (!Array.isArray(reasons)) {
        return []
      }

      const variables = {
        deliveryDays: DeliveryTimeInDays[this.country],
        price: this.boxerPrice,
        womenPrice: this.womenPrice
      }

      const formattedReasons = reasons.map((_, index) => ({
        svg: this.$t(`TryItNow.MixedReasons[${index}].Svg`),
        title: this.$t(`TryItNow.MixedReasons[${index}].Title`, variables),
        description: this.$t(`TryItNow.MixedReasons[${index}].Description`, variables)
      }))

      return formattedReasons
    },
    boxerPrice () {
      return addLocalCurrency(MenPrices[this.country], `${this.locale}-${this.country}`, Currencies[this.country]).replace(/\s/g, '')
    },
    womenPrice () {
      return addLocalCurrency(WomenPrices[this.country], `${this.locale}-${this.country}`, Currencies[this.country]).replace(/\s/g, '')
    }
  },
  methods: {
    scrollLeft () {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.scrollLeft -= 400 // Adjust scroll amount as needed
      }
    },
    scrollRight () {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.scrollLeft += 400 // Adjust scroll amount as needed
      }
    }
  }
}
</script>

<style scoped lang="postcss">
.max-w-1192 {
  @apply mx-auto;
  max-width: 119.2rem;
}

/* Add visual indication of focus */
.horizontal-scroll:focus {
  outline: 2px solid #36C0B6; /* Use your primary color */
  outline-offset: -2px;
}

/* Add scrollbar styling for visual users */
.horizontal-scroll {
  scroll-behavior: smooth; /* For smooth scrolling */
}
</style>
